import PropTypes from 'prop-types';
import noteImg from '@amo/core/assets/images/icons/note.png';
import opinions from '@amo/core/assets/images/logos/opinion.png';

export const Avis = ({ icon = '', name = '', content = '', date, isLast, note = 5 }) => {
    const colClass = isLast ? 'col me-0' : 'col me-4'; // Ajoute une classe conditionnelle

    return (
        <div className={colClass}>
            <div className={'row h-100'}>
                <div className="col bg-white p-4 rounded border">
                    <div className={'d-flex align-items-start text-start justify-content-lg-start'}>
                        <img src={icon} alt="" aria-hidden="true" width={44} height={44} style={{ width: 44, height: 44, borderRadius: '50%', objectFit: 'cover', overflow: 'hidden', flexShrink: 0 }} />
                        <p className={'ms-1 text-dark'}>
                            <span className={'fw-semibold d-inline'}>{name}</span> <i className={'f-12'}>a noté APRIL Moto</i><br />
                            <img src={noteImg} alt={`Note ${note} sur 5`} />
                        </p>
                    </div>
                    <p className={'text-start f-13 mt-2'}>{content}</p>
                    <small className={'text-start d-block mt-4'}>{date} <img src={opinions} alt="" aria-hidden="true" width={98} height={32} className={'mx-2'} loading="lazy"/></small>
                </div>
            </div>
        </div>
    );
};
